module.exports = __webpack_public_path__ + "img/5.84a861f2.jpeg";